'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Utils = require('./Utils');

var _Label = require('./Label');

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = function (_Component) {
    _inherits(Checkbox, _Component);

    function Checkbox() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Checkbox);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.inputId = _this.props.id || (0, _Utils.generateId)(_this.props.name), _this.handleChange = function () {
            // Tell parent to update value with whatever the opposite of the current value is.
            _this.props.updateValue(_defineProperty({}, _this.props.name, !_this.props.value));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Checkbox, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                disabled = _props.disabled,
                hidden = _props.hidden,
                label = _props.label,
                name = _props.name,
                value = _props.value;


            var inputClasses = (0, _classnames2.default)({
                'form__checkbox': true,
                'sr-only': hidden
            });

            return _react2.default.createElement(
                _Label2.default,
                { htmlFor: this.inputId },
                _react2.default.createElement('input', {
                    checked: value,
                    className: inputClasses,
                    disabled: disabled,
                    id: this.inputId,
                    name: name,
                    onChange: this.handleChange,
                    type: 'checkbox',
                    value: 1
                }),
                ' ',
                label
            );
        }
    }]);

    return Checkbox;
}(_react.Component);

Checkbox.propTypes = {
    disabled: _Utils.formControlPropTypes.disabled,
    hidden: _propTypes2.default.bool,
    id: _propTypes2.default.string,
    label: _Utils.formControlPropTypes.label,
    name: _Utils.formControlPropTypes.name,
    updateValue: _Utils.formControlPropTypes.updateValue,
    value: _propTypes2.default.bool.isRequired
};
Checkbox.defaultProps = {
    disabled: false,
    hidden: false,
    value: false
};
exports.default = Checkbox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cotidia/react-ui/lib/Checkbox.js
// module id = 261
// module chunks = 0